// notificationsApi.js
import api from '../api'; // Import your configured axios instance

// GET all notifications (for a specific role)
export const getNotifications = async () => {
  const role = localStorage.getItem('userRole');
  const response = await api.get(`/notifications/${role}`);
  return response.data;
};

// GET My notifications (for the current user, platform = 'WEB' by default)
export const getMyNotifications = async (platform = 'WEB') => {
  const response = await api.get(`/notifications/myNotifications`, {
    params: platform ? { platform } : {}
  });
  return response.data;
};

// Dispatch a custom notification to specific employees across platforms (WEB, MOBILE, ALL)
export const dispatchNotification = async (payload) => {
  const response = await api.post(`/notifications/dispatch`, payload);
  return response.data;
};

// Fetch list of recipients (employees with avatar, position, role, office) for easy selection
export const getNotificationRecipients = async () => {
  const response = await api.get(`/notifications/recipients`);
  return response.data;
};

// Mark a single notification as read
export const MarkAsRead = async (id) => {
  const response = await api.post(`/notifications/mark-read/${id}`, null);
  return response.data;
};

// Mark all notifications as read
export const markAllAsRead = async () => {
  const response = await api.post(`/notifications/mark-all-read`, null);
  return response.data;
};

// Send a test notification to all DEV users
export const sendTestNotificationToDEV = async () => {
  const response = await api.post(`/notifications/send-test-dev`, null);
  return response.data;
};

// Get unread notifications for the authenticated user
export const getUnreadNotificationsPerUser = async (platform = 'WEB') => {
  const employeeId = localStorage.getItem('employeeId');
  const response = await api.get(`/notifications/user/${employeeId}/unread`, {
    params: platform ? { platform } : {}
  });
  return response.data;
};